import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  breadcrumb?: BreadcrumbItem[];
}
export function PageHeader({
  title,
  subtitle,
  eyebrow,
  breadcrumb
}: PageHeaderProps) {
  return <div className="relative pt-40 pb-20 px-6 md:px-12 bg-ink text-bone overflow-hidden flex flex-col items-center text-center" data-id="element-616">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-617">
        <div className="w-full h-full" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, #F5F0E6 1px, transparent 0)',
        backgroundSize: '32px 32px'
      }} data-id="element-618" />
      </div>

      {/* Decorative glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-gold/10 blur-[100px] rounded-full pointer-events-none" data-id="element-619" />

      {eyebrow && <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="text-[10px] font-bold tracking-[0.25em] uppercase text-gold mb-4 relative z-10" data-id="element-620">
          {eyebrow}
        </motion.div>}

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      ease: [0.16, 1, 0.3, 1]
    }} className="text-4xl md:text-5xl lg:text-6xl font-serif tracking-tight mb-4 relative z-10" data-id="element-621">
        {title}
      </motion.h1>

      {subtitle && <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      delay: 0.1,
      ease: [0.16, 1, 0.3, 1]
    }} className="text-bone/70 max-w-2xl text-sm md:text-base relative z-10 leading-relaxed" data-id="element-622">
          {subtitle}
        </motion.p>}

      {breadcrumb && breadcrumb.length > 0 && <motion.nav initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 0.25
    }} aria-label="Breadcrumb" className="mt-8 flex items-center gap-2 text-xs text-bone/50 relative z-10" data-id="element-623">
          {breadcrumb.map((item, i) => <Fragment key={i} data-id="element-624">
              {i > 0 && <ChevronRight className="w-3 h-3 text-bone/30" strokeWidth={2} data-id="element-625" />}
              {item.href ? <Link to={item.href} className="hover:text-gold transition-colors" data-id="element-626">
                  {item.label}
                </Link> : <span className="text-gold font-medium" data-id="element-627">{item.label}</span>}
            </Fragment>)}
        </motion.nav>}
    </div>;
}